import {post, get} from '@/utils/request'

const userApi = {
  /* 系统管理-系统用户-修改状态 */
  updateStates: function (params) {
    return post('/system/member/update-status', {
      id: params.id,
      enable: params.enable
    })
  },
  /* 系统管理-系统用户-添加或编辑初始化（如果是编辑则需要传ID参数，会根据ID返回用户信息, 用户编号、用户帐号只显示，不能编辑。如果是添加操作也可以不请求该接口方法） */
  updateInit: function (id) {
    return get('/system/member/save-update-init', {
      id
    })
  },
  /* 系统管理-系统用户-添加或编辑（如果是编辑则需要传ID参数） */
  saveForm: function (params) {
    return post('/system/member/save-update', {
      roleIds: params.roleIds,
      id: params.id,
      username: params.username,
      password: params.password,
      name: params.name,
      companyName: params.companyName,
      departmentName: params.departmentName,
      phone: params.phone,
      mail: params.mail,
      enable: params.enable
    })
  },
  /* 系统用户下拉列表(查询条件中是需要输入系统人员的可以从这个方法获取所有管理人员，然后可以输入的时候自动补全) */
  pullDown: function () {
    return get('/system/member/pulldown', {})
  },
  /* 系统管理-系统用户-强制下线 */
  offline: function (id) {
    return post('/system/member/offline/' + id)
  },
  /* 系统管理-系统用户-获取用户当前是否是在线状态(用户列表中显示是否是在线状态通过该接口方法) */
  getIsLine: function (id) {
    return get('/system/member/is-online/' + id)
  },
  /* 系统管理-系统用户-删除用户 */
  deleteById: function (id) {
    return post('/system/member/delete/' + id)
  }
}

export default userApi



// WEBPACK FOOTER //
// ./src/api/userApi.js